export default "https://assets.egbcdn.net/assets/packs/_/images/beer/st_patrick/beer-liquid-af977aceb1c6210cf0565cd63683e8d5.png";